__turbopack_context__.v({
  "badge": "index-module-scss-module__CdZfAq__badge",
  "body": "index-module-scss-module__CdZfAq__body",
  "cta": "index-module-scss-module__CdZfAq__cta",
  "header": "index-module-scss-module__CdZfAq__header",
  "text": "index-module-scss-module__CdZfAq__text",
});
